import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanDeactivate, ActivatedRoute, RouterLink, Router, RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { registerLocaleData } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogVideoComponent } from '../pages/mi-agenda/reserva-hora/confirm-dialog-video/confirm-dialog-video.component';
import { VideoconsultaAcompananteComponent } from '../pages/videoconsulta-acompanante/videoconsulta-acompanante.component';
import { VideoconsultaPacienteComponent } from '../pages/videoconsulta-paciente/videoconsulta-paciente.component';

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateVideoGuard implements CanDeactivate<VideoconsultaPacienteComponent | VideoconsultaAcompananteComponent> {
  constructor(private dialogVideo: MatDialog) {

  }
 canDeactivate(
  component: VideoconsultaPacienteComponent | VideoconsultaAcompananteComponent,
  currentRoute: ActivatedRouteSnapshot,
  currentState: RouterStateSnapshot,
  nextState?: RouterStateSnapshot
): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {

  const nextUrl = nextState?.url ?? '';

  const norm = nextUrl.startsWith('/') ? nextUrl : `/${nextUrl}`;
  const isSurvey     = norm.startsWith('/encuesta/');
  const isDashboard  = norm === '/dashboard' || norm.includes('/dashboard');
  const isForcedFlag = (component as any)?.forcedLeave === true;
  const isZoomClosed = sessionStorage.getItem('zoom_ud_video') === 'false';

  if (isSurvey || isDashboard || isForcedFlag || isZoomClosed) {
    return true;
  }

  // si no hay nextState (p. ej. refresh), puedes decidir permitir o no:
  if (!nextState) return true;

  const dialogRef = this.dialogVideo.open(ConfirmDialogVideoComponent);
  return dialogRef.afterClosed();
}

}